module.exports = __webpack_public_path__ + "images/super-sad-filled17a2b5c1a867125060607685ae132ba9.svg";